export default __webpack_public_path__ + "static/media/32.ca788559.jpg";